const middleware = {}

middleware['manager'] = require('../../middleware/manager.ts');
middleware['manager'] = middleware['manager'].default || middleware['manager']

export default middleware
